import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

import DepositorForm from '../../../components/depositor-form/depositor-form.vue';
import { depositorOptions, emptyDepositor } from '../../../utils/depositor';

@Component({
    components: { DepositorForm },
})
export default class DepositorsAdd extends ComponentWithSocket {
    public addDepositor = emptyDepositor();

    depositorOptions = depositorOptions;

    public depositorState = {
        selected: undefined as any,
        isLoading: false
    };

    public depositors: any[] = [];

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.depositors',
            (success: boolean, data: any) => {
                this.depositorState.isLoading = false;
                if (success) {
                    data.forEach((depositor: any) => {
                        this.depositors.push(depositor);
                    });
                }
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        // Assign session values to store for global dispatch
        this.wsListener.onPost(
            'admin.depositors.contracts',
            (success: boolean, data: any) => {
                if (success) {
                    this.$router.push('/depositors');
                } else {
                    alert(data);
                }
            },
        );

        this.depositorState.isLoading = true;
        this.wsListener.sendGet('admin.depositors');
    }

    addDepositorContract() {
        let contractData = {
            contract: { depositor: this.depositorState.selected ? this.depositorState.selected.value : undefined },
            depositor: this.addDepositor,
        };

        this.wsListener.sendPost('admin.depositors.contracts', contractData);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/depositors/add/index.ts